export const nameRegex = /^[a-zA-Zа-яА-ЯёЁ\s\-]*$/;
export const phoneRegex = /^[0-9\s\(\)\+\-]*$/;
export const addressRegex = /^[a-zA-Zа-яА-ЯёЁ\s\-.,\/0-9]*$/;
